import PropTypes from 'prop-types'
import classNames from 'classnames'

import styles from './Sizer.scss'

const mapInput = (str = '', prefix = '') =>
  str
    .split(' ')
    .filter((s) => s !== '')
    .map((s) => `${prefix}${s}`)

const Sizer = ({ children, size, push, pull, className }) => {
  const sizes = mapInput(size, 'u-x')
  const pushes = mapInput(push, 'u-pushx')
  const pulls = mapInput(pull, 'u-pullx')

  return (
    <div className={classNames(styles.base, 'o-gridx__colx', className, sizes, pushes, pulls)}>
      {children}
    </div>
  )
}

Sizer.defaultProps = {
  size: '',
  push: '',
  pull: '',
  children: null,
  className: null,
}

Sizer.propTypes = {
  children: PropTypes.node,
  size: PropTypes.string,
  push: PropTypes.string,
  pull: PropTypes.string,
  className: PropTypes.string,
}
export default Sizer
